import { OnbOptionType } from '../../types';

import { EthnicityFemaleOptionIdType } from './types';

export const ETHNICITY_FEMALE_OPTIONS: OnbOptionType<EthnicityFemaleOptionIdType>[] =
  [
    {
      id: 'african',
      title: 'African',
    },
    {
      id: 'asian',
      title: 'Asian',
    },
    {
      id: 'european',
      title: 'European',
    },
    {
      id: 'arabian',
      title: 'Arabian',
    },
  ];
